import LegalLayout, { Section } from "@/pages/LegalLayout";
import { BRAND } from "@/data/site";

const Ember = ({ children }) => <span className="text-ember">{children}</span>;

export default function Terms() {
  return (
    <LegalLayout eyebrow="Legal" title="Terms of Service" updated="June 1, 2026">
      <p className="font-body text-lg text-zinc-300 leading-relaxed">
        These Terms of Service ("Terms") govern your access to and use of the
        ReBarOS mobile application and related services (the "Service"). By
        creating an account or using the Service, you agree to these Terms. If
        you do not agree, do not use the Service.
      </p>

      <Section heading="1. Subscription & Billing">
        <p>
          ReBarOS is offered as an auto-renewing subscription priced at{" "}
          <Ember>{BRAND.price} per month</Ember>. New users are eligible for a{" "}
          <Ember>3-day free trial</Ember>. Unless cancelled before the trial ends,
          your subscription will automatically begin and you will be charged the
          monthly fee.
        </p>
        <p>
          Subscriptions <Ember>auto-renew</Ember> each month until cancelled. You
          may <Ember>cancel anytime</Ember> through your app store account settings
          or platform of purchase. Cancellation stops future renewals; access
          continues until the end of the current billing period.
        </p>
      </Section>

      <Section heading="2. Refunds">
        <p>
          Because a free trial is provided, monthly charges are generally
          non-refundable except where required by law or by the policies of the
          app store through which you purchased. Refund requests handled by
          Apple or Google are subject to their respective terms.
        </p>
      </Section>

      <Section heading="3. Acceptable Use">
        <p>You agree not to:</p>
        <ul className="list-none space-y-2 pt-1">
          <li className="flex gap-3"><span className="text-ember">·</span> Use the Service for any unlawful purpose or in violation of these Terms.</li>
          <li className="flex gap-3"><span className="text-ember">·</span> Reverse engineer, copy, resell, or exploit any part of the Service.</li>
          <li className="flex gap-3"><span className="text-ember">·</span> Attempt to gain unauthorized access to our systems or other users' data.</li>
          <li className="flex gap-3"><span className="text-ember">·</span> Upload content that is unlawful, harmful, or infringes on others' rights.</li>
        </ul>
      </Section>

      <Section heading="4. Fitness & Medical Disclaimer">
        <div className="border border-ember/40 bg-ember/5 p-6">
          <p className="text-white font-semibold">
            Not medical advice — consult a doctor before starting any program.
          </p>
          <p className="mt-3">
            ReBarOS provides training programs, nutrition guidance, and related
            content for informational and educational purposes only. It is not a
            substitute for professional medical advice, diagnosis, or treatment.
            Always consult a qualified physician or healthcare provider before
            beginning any exercise or nutrition program, especially if you have a
            pre-existing condition or injury. You assume all risk associated with
            physical activity. ReBarOS is not liable for any injury or health
            issue resulting from use of the Service.
          </p>
        </div>
      </Section>

      <Section heading="5. Intellectual Property">
        <p>
          All content, trademarks, software, and materials provided through the
          Service are owned by ReBarOS or its licensors and are protected by
          applicable intellectual property laws. You are granted a limited,
          non-exclusive, non-transferable license to use the Service for personal,
          non-commercial purposes.
        </p>
      </Section>

      <Section heading="6. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, the Service is provided "as is"
          without warranties of any kind. ReBarOS shall not be liable for any
          indirect, incidental, or consequential damages arising from your use of
          the Service.
        </p>
      </Section>

      <Section heading="7. Governing Law">
        <p>
          These Terms are governed by and construed in accordance with the laws
          of <Ember>the State of South Dakota, United States</Ember>, without regard to its conflict of
          law provisions. Any disputes shall be resolved in the courts located in
          that jurisdiction.
        </p>
      </Section>

      <Section heading="8. Contact">
        <p>
          Questions about these Terms? Contact us at{" "}
          <a href={`mailto:${BRAND.email}`} className="text-ember hover:underline" data-testid="terms-contact-email">
            {BRAND.email}
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
